export default __webpack_public_path__ + "static/media/Logo.b43d2c16.png";